module.exports = __webpack_public_path__ + "static/media/fxconcept.473cc150.png";